import React, { useEffect, useMemo, useRef, useState } from "react";
import blog1 from "../../../../assets/blog1.jpg";
import blog2 from "../../../../assets/blog2.jpg";
import blog3 from "../../../../assets/blog3.png";
import blog4 from "../../../../assets/blog4.jpg";
import blog5 from "../../../../assets/blog5.jpg";
import blog6 from "../../../../assets/blog6.jpg";
import blog7 from "../../../../assets/blog7.jpg";
import blog8 from "../../../../assets/blog8.jpg";
import blog9 from "../../../../assets/blog9.jpg";
import blogA from "../../../../assets/blog-1.png";
import blogB from "../../../../assets/blog-2.png";
import blogC from "../../../../assets/blog-3.png";
import arrowdown from "../../../../assets/arrow-down.png";
import searchImg from "../../../../assets/search.png";

const blogs = [
  { category: "food", title: "how smart pos software is transforming small restaurants", image: blog1, author: "Olivia Rhye", date: "20 Jan 2022", avatar: blogA },
  {
    category: "food",
    title: (
      <>
        ways to boost customer experience in retail with{" "}
        be
        <span className="inline-block scale-x-[-1] tracking-[0px]">
          e
        </span>
        mz
      </>
    ),
    image: blog2,
    author: "Phoenix Baker",
    date: "19 Jan 2022",
    avatar: blogB,
  }
  ,
  { category: "food", title: "why your business needs a digital storefront", image: blog3, author: "Lana Steiner", date: "18 Jan 2022", avatar: blogC },
  { category: "healthcare", title: "how smart pos software is transforming small restaurants", image: blog4, author: "Olivia Rhye", date: "20 Jan 2022", avatar: blogA },
  {
    category: "fashion", title: (
      <>
        ways to boost customer experience in retail with{" "}
        be
        <span className="inline-block scale-x-[-1] tracking-[0px]">
          e
        </span>
        mz
      </>
    ), image: blog5, author: "Phoenix Baker", date: "19 Jan 2022", avatar: blogB
  },
  { category: "taxi booking", title: "why your business needs a digital storefront", image: blog6, author: "Lana Steiner", date: "18 Jan 2022", avatar: blogC },
  { category: "healthcare", title: "how smart pos software is transforming small restaurants", image: blog7, author: "Olivia Rhye", date: "20 Jan 2022", avatar: blogA },
  {
    category: "fashion", title: (
      <>
        ways to boost customer experience in retail with{" "}
        be
        <span className="inline-block scale-x-[-1] tracking-[0px]">
          e
        </span>
        mz
      </>
    ), image: blog8, author: "Phoenix Baker", date: "19 Jan 2022", avatar: blogB
  },
  { category: "healthcare", title: "why your business needs a digital storefront", image: blog9, author: "Lana Steiner", date: "18 Jan 2022", avatar: blogC },
];

const viewMoreBlogs = [
  { category: "food", title: "how smart pos software is transforming small restaurants", image: blog1, author: "Olivia Rhye", date: "20 Jan 2022", avatar: blogA },
  {
    category: "food", title: (
      <>
        ways to boost customer experience in retail with{" "}
        be
        <span className="inline-block scale-x-[-1] tracking-[0px]">
          e
        </span>
        mz
      </>
    ), image: blog2, author: "Phoenix Baker", date: "19 Jan 2022", avatar: blogB
  },
  { category: "food", title: "why your business needs a digital storefront", image: blog3, author: "Lana Steiner", date: "18 Jan 2022", avatar: blogC },
];

function BlogCard({ item }) {
  return (
    <article className="rounded-xl shadow-md hover:shadow-lg transition bg-white overflow-hidden">
      <img
        src={item.image}
        alt={item.title}
        className="w-full h-40 sm:h-48 md:h-56 object-cover"
      />
      <div className="p-4 sm:p-5">
        <p className="text-[10px] sm:text-xs text-purple-600 font-medium mb-1">{item.category}</p>
        <h2 className="text-[14px] sm:text-[15px] md:text-base font-semibold leading-snug ">
          {item.title}
        </h2>
        <div className="flex items-center gap-3 mt-4 sm:mt-5">
          <img src={item.avatar} alt={item.author} className="w-7 h-7 sm:w-8 sm:h-8 rounded-full object-cover" />
          <div>
            <p className="text-sm font-medium text-gray-900">{item.author}</p>
            <p className="text-[11px] sm:text-xs text-gray-500">{item.date}</p>
          </div>
        </div>
      </div>
    </article>
  );
}

const BlogNavContent = () => {
  const [query, setQuery] = useState("");
  const [showMore, setShowMore] = useState(false);
  const [search, setSearch] = useState("");
  const [showViewBtn, setShowViewBtn] = useState(true);
  const allItems = useMemo(() => (showMore ? [...blogs, ...viewMoreBlogs] : blogs), [showMore]);
  const searchInputRef = useRef(null);

  const getTitleText = (title) => {
    if (typeof title === "string") return title;
    if (typeof title === "object") return title.props.children?.map((c) => (typeof c === "string" ? c : "")).join("") || "";
    return "";
  };

  const filtered = allItems.filter((item,key) => {
    const titleText = getTitleText(item.title);
    return titleText.toLowerCase().includes(query.toLowerCase());
  });

  function searchData() {
    console.log("this is searchData() method");
    setShowMore(true);
    if (search === "") {
      setShowMore(false);
      setShowViewBtn(true);
    }
    else {
      setShowViewBtn(false);
    }
    setQuery(search);
    searchInputRef.current.focus();
  }

  useEffect(() => {
    searchInputRef.current.focus()
  }, []);

  return (
    <section className="w-full flex justify-center font-[Lexend] bg-white">
      <div className="w-full max-w-[1500px] px-6 sm:px-10 md:px-16 lg:px-29 mt-8 sm:mt-10 mb-16 sm:mb-20">
        {/* 🔍 Search Section */}
        {/* <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full pb-8 sm:pb-10">
          <div className="relative w-full sm:max-w-xl xl-2xl:max-w-[600px] mt-10 mx-auto">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  searchData();
                }
              }}
              placeholder="search"
              className="w-full border border-[#D0D5DD] rounded-full py-2 px-8 sm:py-2.5 sm:px-10 md:py-3 md:px-12 focus:outline-none focus:ring-2 focus:ring-purple-500"
              aria-label="Search blogs"
              ref={searchInputRef}
            />
            <span
              className="absolute left-4 top-1/2 -translate-y-1/2"
              aria-hidden="true"
            >
              <img src={searchImg} alt="" className="w-4 h-4 sm:w-5 sm:h-5 opacity-70" />
            </span>
          </div>
          <button
            type="button"
            onClick={() => searchData()}
            className="bg-[#6E3FC6] text-white px-4 py-2 sm:px-5 sm:py-2 rounded-full text-bold hover:bg-[#5b32a3] transition"
          >
            search
          </button>
        </div> */}

        <div className="flex w-full sm:max-w-[290px] md:max-w-[500px] xl:max-w-[600px] mt-10 mx-auto gap-2 pb-[30px]">
          {/* Search Input  md:max-w-[600px] sm:max-w-[290px] xl:max-w-[600px] */}
          <div className="relative flex-1">
            <input
              type="text"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  searchData();
                }
              }}
              placeholder="search"
              className="w-full border border-[#D0D5DD] rounded-full py-2 px-8 sm:py-2.5 sm:px-10 md:py-3 md:px-12 focus:outline-none focus:ring-2 focus:ring-purple-500 transition-all"
              aria-label="Search blogs"
              ref={searchInputRef}
            />
            <span
              className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none"
              aria-hidden="true"
            >
              <img src={searchImg} alt="search icon" className="w-4 h-4 sm:w-5 sm:h-5 opacity-70" />
            </span>
          </div>

          {/* Search Button */}
          <button
            type="button"
            onClick={() => searchData()}
            className="bg-[#6E3FC6] text-white px-4 py-2 sm:px-5 sm:py-2 rounded-full font-bold hover:bg-[#5b32a3] transition"
          >
            search
          </button>
        </div>


        {/* 📰 Blog Cards */}
        <div className="grid gap-6 sm:gap-8 md:gap-10 lg:gap-12 grid-cols-1 sm:grid-cols-1 lg:grid-cols-3">

          {filtered.length > 0 ? (
            filtered.map((item, idx) => (
              <div key={idx}>
                <BlogCard key={`${item.title}-${idx}`} item={item} />
              </div>
            ))
          ) : (
            <p className=" ml-[110px] md:ml-[270px] lg-xl:ml-[350px] xl-2xl:ml-[500px] w-[200px] mb-[-2rem] lowercase">No match found</p>
          )}

        </div>

        {/* ⬇️ View More Button Centered */}
        {showViewBtn &&
          <div className="flex justify-center items-center mt-10 sm:mt-12">
            {!showMore ? (

              <button
                type="button"
                onClick={() => { setShowMore(true)}} // added the screen to come to the starting of the page onclicking it
                className="flex px-4 py-2 sm:px-6 rounded-[10px] bg-purple-50 border border-gray-300 hover:border-gray-400 hover:bg-purple-100 transition group-hover:scale-110 text-[#6941C6] font-semibold "
                //  className="group focus:outline-none"
                aria-label="See less"
                title="See less"
              >
                <img
                  src={arrowdown}
                  alt="View less"
                /><span className="font-inter font-medium text-[18px] leading-[24px] tracking-normal"
                >view more</span>

              </button>
            ) : (
              <button
                type="button"
                onClick={() => { setShowMore(false) }} // added the screen to come to the starting of the page onclicking it
                className="flex px-4 py-2 sm:px-6 rounded-[10px] bg-purple-50 border border-gray-300 hover:border-gray-400 hover:bg-purple-100 transition group-hover:scale-110 text-[#6941C6] font-semibold "
                //  className="group focus:outline-none"
                aria-label="See less"
                title="See less"
              >
                <img
                  src={arrowdown}
                  alt="View less"
                /><span className="font-inter font-medium text-[18px] leading-[24px] tracking-normal"
                >view less</span>

              </button>
            )}
          </div>
        }

      </div>
    </section>
  );
};

export default BlogNavContent;
